// The marvin-auth api is versioned semver wise
// this variables indicates the compatbility this current build supports
export const API_COMPATIBLE_VERSION_RANGE = '~4.3.6';
export { defaultServerConfig } from './config/DefaultServerConfig';
export { auth } from './auth';
export { config } from './config';
export { users } from './users';
export { roles } from './roles';
export { register } from './register';
export { password } from './password';
export { email } from './email';
export { reset } from './reset';
export { metadata } from './metadata';
export { Preloader } from './react/components/preloader/Preloader';
export { LoginRoute } from './react/components/route/LoginRoute';
export { PrivateRoute } from './react/components/route/PrivateRoute';
export * from './hooks/useIsAuthenticated';
export * from './hooks/useCurrentUser';
export * from './utils/error.utils';
export * from './types/index';
